<div class="add-hr-manager-container">
  <div class="header">
    <h2><fa-icon [icon]="faUserPlus" class="text-primary mr-2"></fa-icon> Add HR Manager</h2>
    <p class="header-description">Create a new HR manager account with access to the HR panel.</p>
  </div>

  <div class="card">
    <div class="card-body">
      <div *ngIf="successMessage" class="alert alert-success">
        {{ successMessage }}
      </div>
      
      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>
      
      <form [formGroup]="hrManagerForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-3">
          <label for="username">Username *</label>
          <input 
            type="text" 
            id="username" 
            formControlName="username" 
            class="form-control" 
            [class.is-invalid]="hrManagerForm.get('username')?.invalid && hrManagerForm.get('username')?.touched"
          >
          <div class="invalid-feedback" *ngIf="hrManagerForm.get('username')?.errors?.['required'] && hrManagerForm.get('username')?.touched">
            Username is required
          </div>
          <div class="invalid-feedback" *ngIf="hrManagerForm.get('username')?.errors?.['minlength'] && hrManagerForm.get('username')?.touched">
            Username must be at least 3 characters
          </div>
        </div>
        
        <div class="form-group mb-3">
          <label for="email">Email Address *</label>
          <input 
            type="email" 
            id="email" 
            formControlName="email" 
            class="form-control" 
            [class.is-invalid]="hrManagerForm.get('email')?.invalid && hrManagerForm.get('email')?.touched"
          >
          <div class="invalid-feedback" *ngIf="hrManagerForm.get('email')?.errors?.['required'] && hrManagerForm.get('email')?.touched">
            Email is required
          </div>
          <div class="invalid-feedback" *ngIf="hrManagerForm.get('email')?.errors?.['email'] && hrManagerForm.get('email')?.touched">
            Please enter a valid email address
          </div>
        </div>
        
        <div class="form-group mb-3">
          <label for="password">Password *</label>
          <input 
            type="password" 
            id="password" 
            formControlName="password" 
            class="form-control" 
            [class.is-invalid]="hrManagerForm.get('password')?.invalid && hrManagerForm.get('password')?.touched"
          >
          <div class="invalid-feedback" *ngIf="hrManagerForm.get('password')?.errors?.['required'] && hrManagerForm.get('password')?.touched">
            Password is required
          </div>
          <div class="invalid-feedback" *ngIf="hrManagerForm.get('password')?.errors?.['minlength'] && hrManagerForm.get('password')?.touched">
            Password must be at least 8 characters
          </div>
        </div>
        
        <div class="form-group mb-3">
          <label for="confirmPassword">Confirm Password *</label>
          <input 
            type="password" 
            id="confirmPassword" 
            formControlName="confirmPassword" 
            class="form-control" 
            [class.is-invalid]="(hrManagerForm.get('confirmPassword')?.invalid || hrManagerForm.errors?.['passwordMismatch']) && hrManagerForm.get('confirmPassword')?.touched"
          >
          <div class="invalid-feedback" *ngIf="hrManagerForm.get('confirmPassword')?.errors?.['required'] && hrManagerForm.get('confirmPassword')?.touched">
            Please confirm your password
          </div>
          <div class="invalid-feedback" *ngIf="hrManagerForm.errors?.['passwordMismatch'] && hrManagerForm.get('confirmPassword')?.touched">
            Passwords do not match
          </div>
        </div>
        
        <div class="info-message" *ngIf="companyId">
          <fa-icon [icon]="faInfoCircle" class="info-icon"></fa-icon>
          The HR manager will be created under your company (ID: {{ companyId }}).
        </div>
        
        <div class="form-actions">
          <button type="button" routerLink="/hr/dashboard" class="btn btn-secondary">
            <fa-icon [icon]="faTimes"></fa-icon> Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
            <fa-icon [icon]="faSave"></fa-icon> 
            <span *ngIf="!isSubmitting">Create HR Manager</span>
            <span *ngIf="isSubmitting">Creating...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div> 